/* @preserve Side effect: custom Quill blot registration */
import Quill from "quill";
import "./quillBlots/passiveVoice";
import "./quillBlots/longSentence";

const Embed = Quill.import("blots/block/embed");

class CustomImageBlot extends Embed {
  static blotName = "customImage";
  static tagName = "div";
  static className = "ql-customImage";

  static create(value) {
    const node = super.create();
    node.classList.add(CustomImageBlot.className);
    node.setAttribute("role", "img");
    node.setAttribute("aria-label", value.alt || 'Image');
    node.setAttribute("tabindex", "0");

    const img = document.createElement("img");
    img.setAttribute("src", value.src || "");
    img.setAttribute("alt", value.alt || "");
    img.setAttribute("title", value.attribution || "");
    img.setAttribute("loading", "lazy");
    img.style.maxWidth = "100%";
    img.style.display = "block";

    node.appendChild(img);
    return node;
  }

  static value(node) {
    const img = node.querySelector("img");
    return {
      src: img?.getAttribute("src") || "",
      alt: img?.getAttribute("alt") || "",
      attribution: img?.getAttribute("title") || "",
    };
  }
}

// Register blot on both Quill instances
Quill.register(CustomImageBlot);

export default Quill;
